<!--万达电影app-H5-万达谷仓主页面-->
<template>
  <div class="home">
    <img src="./img2.png" alt="">
    <div class="clickBlock area1" @click="area1Fun"></div>
    <div class="clickBlock area2" @click="area2Fun"></div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
  methods:{
    area1Fun(){
      if(this.$route.query.src==='mini'){
        this.$router.push({
          name:'RightsList',
          query: { src:  'mini' }
        });
      }else {
        this.$router.push('RightsList')
      }

    },
    area2Fun(){
      this.$router.back(-1)
    }
  }
};
</script>
<style lang="less" scoped>
  .home {
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    position: relative;
    >img {
      position: relative;
      width: 100%;
      height: auto;
      //height: 100%;
    }
    .area1 {
      width: 100vw;
      height: 17vh;
      top: 32vh;
    }
    .area2 {
      width: 12vw;
      height: 12vw;
      top: 5vh;
    }
  }
</style>
